/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
var r = /* @__PURE__ */ ((p) => (p[p.PopupList = 0] = "PopupList", p[p.TagsList = 1] = "TagsList", p))(r || {});
export {
  r as ActiveDescendant
};
